import vi from "./translations.vi.js";
import zh from "./translations.zh.js";
import en from "./translations.en.js";

export const customerTranslations = { vi, zh, en };
